import { useTheme } from '@mui/material';
import { colors } from '@watter/shared-components';

const NoInternetIcon = () => {
    const theme = useTheme();
    const color = theme.palette.mode === 'dark' ? colors.white : colors.blackColor;
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.8567 18.7167C13.2257 24.3379 10.0584 31.9659 10.0515 39.9224C10.0446 47.8789 13.1987 55.5123 18.82 61.1433C24.4413 66.7743 32.0692 69.9416 40.0257 69.9485C47.9823 69.9554 55.6157 66.8013 61.2467 61.18M66.82 53.44C69.6405 47.8102 70.6181 41.4357 69.6143 35.2195C68.6105 29.0032 65.6762 23.2604 61.227 18.8046C56.7778 14.3488 51.0394 11.4059 44.8246 10.3928C38.6099 9.37976 32.2339 10.3479 26.6 13.16M11.9999 30H29.9999M43.3332 30H67.9999M11.9999 50H49.9999M63.3332 50H67.9999M38.3334 10C36.3449 13.1846 34.6778 16.559 33.3567 20.0733M30.5334 30.5567C28.2667 43.98 30.8667 58.0367 38.3334 70M41.6667 10C46.689 18.0425 49.6106 27.2177 50.1633 36.6833M49.4733 49.41C48.2443 56.7182 45.5918 63.714 41.6667 70M10 10L70 70"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default NoInternetIcon;
